import "react-datepicker/dist/react-datepicker.css";
import "~/components/blocks/InputDate/styles.scss";

import { ThemeProvider } from "@emotion/react";
import * as Sentry from "@sentry/nextjs";
import { NextPage } from "next";
import NextApp from "next/app";
import NextHead from "next/head";
import React from "react";
import { RecoilRoot } from "recoil";

import { GoogleAnalytics } from "~/components/functionals";
import { GlobalStyle } from "~/components/styles/global_style";
import { theme } from "~/components/styles/theme";
import { withApollo } from "~/graphql/with-apollo";
import { publicPath } from "~/utils/path";

type Props = {
  children: React.ReactNode;
};

const CustomApp: React.VFC<Props> = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <NextHead>
        <meta name="robots" content="noindex,nofollow" />
        <title>処方箋情報事前送信サービス</title>
        <link
          id="favicon"
          rel="shortcut icon"
          href={`${publicPath("/icons/favicon.ico")}`}
        ></link>
        <link
          rel="apple-touch-icon"
          href={`${publicPath("/icons/apple-touch-icon.png")}`}
        ></link>
        <link
          rel="icon"
          href={`${publicPath("/icons/android-chrome-192x192.png")}`}
        ></link>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0"
        />
      </NextHead>
      <GoogleAnalytics />
      <GlobalStyle />
      <RecoilRoot>{props.children}</RecoilRoot>
    </ThemeProvider>
  );
};

class App extends NextApp {
  render() {
    const { Component, pageProps } = this.props;

    return (
      <Sentry.ErrorBoundary>
        <CustomApp>
          <Component {...pageProps} />
        </CustomApp>
      </Sentry.ErrorBoundary>
    );
  }
}

export default withApollo(App as unknown as NextPage);
